import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlPrefix } from '../constants/url-prefix.constants';
import { ILookup } from '../interfaces/ILookup.interface';

@Injectable()
export class DictionaryService {
    constructor(private http: HttpClient) { }

    getDefaultDictionaryLookups(): Observable<Array<ILookup<number>>> {
        return this.http.get<Array<ILookup<number>>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/lookups/defaultdictionaries`);
    }
}
